"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unsubscriber = exports.smoothing = exports.movingWindow = exports.bufferTimeNonEmpty = exports.collectIntermediates = exports.summarizeThrough = void 0;
const immer_1 = require("immer");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const R = __importStar(require("ramda"));
const utils_1 = require("./utils");
function summarizeThrough(summarizer) {
    return function (source) {
        let valuesAccumulator = [];
        return source.pipe((0, operators_1.tap)(v => {
            valuesAccumulator.push(v);
        }), (0, rxjs_1.concatWith)((0, rxjs_1.defer)(() => {
            const r = summarizer((0, immer_1.freeze)(valuesAccumulator));
            valuesAccumulator = []; // Clear the array
            return r;
        })));
    };
}
exports.summarizeThrough = summarizeThrough;
function collectIntermediates(totalDuration, intermediateInterval, sources) {
    return (0, rxjs_1.from)(sources).pipe((0, rxjs_1.mergeAll)(), (0, rxjs_1.takeUntil)((0, rxjs_1.timer)(totalDuration * 1000)), bufferTimeNonEmpty(intermediateInterval * 1000), (0, rxjs_1.timeInterval)(), (0, rxjs_1.map)(({ value, interval }) => {
        const byteCount = R.sum(value);
        return {
            byteCount: byteCount,
            duration: interval / 1000
        };
    }));
}
exports.collectIntermediates = collectIntermediates;
function bufferTimeNonEmpty(minTimeSpan) {
    return function (source) {
        const closingNotifier = new rxjs_1.Subject();
        return source.pipe((0, operators_1.tap)(_ => setTimeout(() => closingNotifier.next(), 0)), // setTimeout is needed to let the current element to be buffered before the buffer is closed.
        (0, rxjs_1.buffer)(closingNotifier.pipe((0, rxjs_1.throttleTime)(minTimeSpan, undefined, { leading: false, trailing: true }))), (0, rxjs_1.filter)(v => v.length > 0));
    };
}
exports.bufferTimeNonEmpty = bufferTimeNonEmpty;
/**
 * Generates a moving windows of values from source observable. Emits for every source value.
 * For example, when the source emits: [1,2,3,4,5], the result for size 3 will be [[1], [1,2], [1,2,3], [2,3,4], [3,4,5]]
 * @param size : maximum window size
 * @returns Moving windows with source values. Windows are never empty.
 */
function movingWindow(size) {
    return function (source) {
        return source.pipe((0, rxjs_1.scan)((acc, value) => R.takeLast(size, R.append(value, acc)), []));
    };
}
exports.movingWindow = movingWindow;
/**
 * Applies a moving window summation to the CollectedData values, with a window of size 3.
 * @returns both the original value and the smoothed value
 */
function smoothing() {
    return function (source) {
        return source.pipe(movingWindow(3), (0, rxjs_1.map)(v => ({
            original: R.last(v),
            smoothed: (0, utils_1.sumLoadChunks)(v)
        })));
    };
}
exports.smoothing = smoothing;
const unsubscriber = (callback) => (source) => (0, rxjs_1.defer)(() => {
    let completed = false;
    let errored = false;
    return source.pipe((0, operators_1.tap)({
        error: () => errored = true,
        complete: () => completed = true,
    }), (0, operators_1.finalize)(() => {
        if (!errored && !completed) {
            callback();
        }
    }));
});
exports.unsubscriber = unsubscriber;
/*
export function materialize<T>(): OperatorFunction<T, Notification<T> & ObservableNotification<T>> {
return operate((source, subscriber) => {
source.subscribe(
  createOperatorSubscriber(
    subscriber,
    (value) => {
      subscriber.next(Notification.createNext(value));
    },
    () => {
      subscriber.next(Notification.createComplete());
      subscriber.complete();
    },
    (err) => {
      subscriber.next(Notification.createError(err));
      subscriber.complete();
    }
  )
);
});
}
*/ 
//# sourceMappingURL=observable.js.map